/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OpcuaConfig } from '../../models/opcua-config';

export interface GetOpcuaConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected opcua configuration
 */
  opcuaUid: string;
}

export function getOpcuaConfiguration(http: HttpClient, rootUrl: string, params: GetOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<OpcuaConfig>> {
  const rb = new RequestBuilder(rootUrl, getOpcuaConfiguration.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('opcuaUid', params.opcuaUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OpcuaConfig>;
    })
  );
}

getOpcuaConfiguration.PATH = '/stations/{uid}/opcua/{opcuaUid}';
